import React, { useContext } from 'react';
import LoginHeader from '../../components/Headers/LoginHeader';
import LoginFooter from '../../components/Footers/LoginFooter';
import BusinessSingle from '../../components/BusinessSingle';
import { UserContext } from '../../context/User';
import AdminHeader from '../../components/Headers/AdminHeader';
import ContractingOfficerSingle from 'components/ContractingOfficerSingle';

const ContractingOfficerSinglePage = () => {
  const { user } = useContext(UserContext);
  const role = user && user.roles && user.roles[0].role_description;

  return (
    <>  
      {role === "admin" ? <AdminHeader /> : <LoginHeader />}
      <main>
        <ContractingOfficerSingle />
      </main>
      <LoginFooter />
    </>
  )
}

export default ContractingOfficerSinglePage;